<template>
	<div>
		<div class="pa-40 textAlignCenter" v-if="selectedItem.id">
			<AssetResume_n :data="selectedItem" type="CA" :last_action_taken="last_action_taken"/>
			<template v-if="canReviewThis">
				<v-layout v-if="can_action('forward')" class="text_align_left">
					<in_asset_class :value.sync="asset_class" md="4"/>
				</v-layout>
				<wf_review :parent.sync="this_c"/>
			</template>
			<div v-else>
				<h3 v-if="gettedWorkflowNull">Ud no puede evaluar este asset</h3>
				<h3 v-else>Revisando si puede evaluar...</h3>
			</div>
		</div>
		<div class="pa-40 textAlignCenter" v-else>
			<div v-if="error">
				{{error}}
			</div>
			<div v-else>
				Cargando...
			</div>
		</div>

		<v-dialog persistent v-model="cantReviewDialog" width="400">
			<v-card class="pa-20 textAlignCenter">
				<h3>Error</h3>
				<br>
				<div>
					{{error}}
				</div>
				<br>
				<div>
					<v-btn color="primary" @click="goToHome">
						<span>Aceptar</span>
					</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<fs1-dialog :id="`asset_res-${id}`">
			<template v-slot:body>
				<h3 v-if="selectedItem.state===2">Activo aprobado <v-icon>check</v-icon></h3>
				<h3 v-if="selectedItem.state===1">Activo rechazado <v-icon>cancel</v-icon></h3>
      </template>
    </fs1-dialog>

		<wf_confirm :confirm="confirm" :last_action_taken="last_action_taken"/>
	</div>

</template>

<script>
import asset_review from '@/modules/CA_SP/mixins/asset_review.js';
export default {
  mixins: [asset_review],
  data() {
    return {
			type:'my_pending_ca',
      pending_types: ['my_pending_ca'],
      asset_folder: 'ca',
      asset_type: 'critical_asset',
		};
	},
};
</script>
